import { acceptOfferService } from '../api/acceptOffer';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';
/**
 * Initializes a put service for offers
 * @returns service function for put
 *
 */
const useAcceptOfferService = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();
    return async (offerId: string) => {
        if (!authenticationData) {
            throw Error('Not authenticated');
        }
        return await acceptOfferService(proxyBaseUrl, apiKey, applicationReferenceNumber, authenticationData, offerId);
    };
};
export default useAcceptOfferService;
